<template>
    <div class="content-wrapper">
        <app-page-top-section :title="$t('brands')">
            <app-default-button
                    :title="$addLabel('brand')"
                    @click="openModal"
            />
        </app-page-top-section>
        <app-table
                id="brands-table"
                :options="options"
                @action="triggerActions"
        />
        <app-brand-create-edit
            v-if="isModalActive"
            v-model="isModalActive"
            :selected-url="selectedUrl"
        />

        <app-confirmation-modal
                v-if="confirmationModalActive"
                icon="trash-2"
                modal-id="app-confirmation-modal"
                @confirmed="confirmed('brands-table')"
                @cancelled="confirmationModalActive = false"
        />
    </div>
</template>

<script>
    import BrandsMixins from "../../Mixins/BrandsMixins";

    export default {
        name: "Brands",
        mixins: [BrandsMixins],
        methods: {
            openModal() {
                this.isModalActive = true;
                this.selectedUrl = null;
            }
        }
    }
</script>

<style scoped>

</style>